module.exports = __webpack_public_path__ + "static/img/home_img_01@3x.ea19ff0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main-page/home_img_01@3x.jpg
// module id = 84
// module chunks = 49